"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartType = void 0;
var ChartType;
(function (ChartType) {
    ChartType["PRSizeToMergeTime"] = "PRSizeToMergeTime";
    ChartType["PRCycleTime"] = "PRCycleTime";
    ChartType["ThroughputIssueCount"] = "ThroughputIssueCount";
    ChartType["ThroughputStoryPoints"] = "ThroughputStoryPoints";
    ChartType["DefectDensity"] = "DefectDensity";
    ChartType["PRSize"] = "PRSize";
    ChartType["PRTimeToMerge"] = "PRTimeToMerge";
    ChartType["ClosedUnMergedPrs"] = "ClosedUnMergedPrs";
    ChartType["AbandonedWork"] = "AbandonedWork";
    ChartType["IssueDoneByType"] = "IssueDoneByType";
    ChartType["WorkClassification"] = "WorkClassification";
    ChartType["DistributionClassification"] = "DistributionClassification";
    ChartType["IssueCycleTimeByType"] = "IssueCycleTimeByType";
    ChartType["IssueCycleTimeByComponent"] = "IssueCycleTimeByComponent";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
//# sourceMappingURL=charts.js.map